export enum LayerPatchInstructionKind {
  UPDATE_EXPERIMENT_RESERVATION = 'updateExperimentReservation',
  REMOVE_EXPERIMENT = 'removeExperiment',
  UPDATE_NAME = 'updateName',
  UPDATE_DESCRIPTION = 'updateDescription',
}

interface UpdateExperimentReservationPatchInstruction {
  kind: LayerPatchInstructionKind.UPDATE_EXPERIMENT_RESERVATION;
  experimentKey: string;
  reservationPercent: number;
}

interface RemoveExperimentPatchInstruction {
  kind: LayerPatchInstructionKind.REMOVE_EXPERIMENT;
  experimentKey: string;
}

interface UpdateNamePatchInstruction {
  kind: LayerPatchInstructionKind.UPDATE_NAME;
  name: string;
}

interface UpdateDescriptionPatchInstruction {
  kind: LayerPatchInstructionKind.UPDATE_DESCRIPTION;
  description: string;
}

export type LayerPatchInstruction =
  | UpdateExperimentReservationPatchInstruction
  | RemoveExperimentPatchInstruction
  | UpdateNamePatchInstruction
  | UpdateDescriptionPatchInstruction;
